module.exports = __webpack_public_path__ + "static/TheMetSans-BoldItalic-97a9d306475ccf0ef68b7fc255983ae3.woff";